export const themeOptions = [
  {
    color: [
      '#224B87',
      '#44A1DF',
      '#8650FF',
      '#FFA22D',
      '#F45853',
      '#6d6d93',
      '#8c97b0',
      '#C87954',
      '#8DB0FF',
      '#a9b3b7',
      '#1ECE9A',
      '#2B508A',
    ]
  }
]



// WEBPACK FOOTER //
// ./src/components/common/WordCloudChart/WordCloudConf.js